import { EpimsBaseEntityDto } from './epim-base.dto';

export class PlractivityactionhistoryDto extends EpimsBaseEntityDto {

      PLRActivityActionHistoryId: string;    
      StaffId:string;
      PLStageActivityId:string;
      PLRLicenceId:string;
      Remarks:string;
      Percentage:string;  
      CompletedDate:Date; 
      
      CreatedDate:Date;
      UpdatedDate:Date;           
      SubscriberId:string;
      ActivityActionsPersonId:string;
}
